import { AppState } from '../../app/state/AppState';
import { normalizedContentKey } from '../../home/reducers/NormalizedContentReducer';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ExploreContentApi_ContentType } from '../../ts/ServerApi/types/IContent';

export function selectItemFromHomeState(state: AppState, contentId: string, contentType: ExploreContentApi_ContentType): IContentInfo {
  return state.normalizedContentById[normalizedContentKey(contentId, contentType)];
}

export function selectShowWelcomeChannelForUserFromAppState(state: AppState) {
  return state.session.info.user.showWelcomeScreen && !state.home.welcomeChannel.userDismissedWelcomeChannel;
}

export function selectShowDefaultWelcomeChannelFromAppState(state: AppState) {
  return !FeatureFlags.serverWelcomeChannelEnabled || welcomeChannelEnabled(state);
}

export function welcomeChannelEnabled(state: AppState) {
  if (state.home.welcomeChannel.welcomeChannelInfo) {
    return state.home.welcomeChannel.welcomeChannelInfo.welcomeChannelEnabledForServer;
  }
  return false;
}

export function selectWelcomeChannelFooterFromAppState(state: AppState) {
  if (FeatureFlags.serverWelcomeChannelEnabled && state.home.welcomeChannel.welcomeChannelInfo) {
    return state.home.welcomeChannel.welcomeChannelInfo.welcomeChannelServerFooter;
  }
  return undefined;
}
